import type { FeatureManifest } from '../registry.js';

/** SY-01 account link (OVL-04 save prompt, email magic link, Apple/Google, conflict chooser) and SO-05 transfer (confirmed first). */
export default {
  id: 'account',
  provides: ['savePrompt', 'accountLink', 'emailLink', 'linkConflict', 'transferConfirm'],
  links: ['email', 'transfer'],
  load: () => import('./index.js'),
} satisfies FeatureManifest;
